import{PublicClientApplication}from"@azure/msal-browser";

export const BLUE="#1D5FA5";
export const GOLD="#E89A0A";

export const msalConfig={
  auth:{
    clientId:"861cd354-a875-4284-8ef9-52a865503703",
    authority:"https://login.microsoftonline.com/bdf673b5-6209-4e5c-b23b-900a333672b1",
    redirectUri:window.location.origin
  },
  cache:{cacheLocation:"localStorage",storeAuthStateInCookie:false}
};

// Alias for backward compatibility
export const MSAL_CONFIG=msalConfig;

export const msalInstance=new PublicClientApplication(msalConfig);
export const SCOPES=["User.Read","Files.ReadWrite","Sites.ReadWrite.All","User.Read.All","Mail.Send"];
export const TEAMS_SCOPES=[...["User.Read","Files.ReadWrite","Sites.ReadWrite.All","User.Read.All","Mail.Send"],"Group.Read.All"];

export const SP_SITE="dacus.sharepoint.com,f5eb1ab9-c29d-43aa-88b6-4fb74e1df91c,6b82be9b-d56e-40e9-9f51-b3d95bbff5f9";
export const LIST_TASKS="97fdda2c-e7a0-4826-90cf-3460abed1474";
export const LIST_COMPANY="8b803cb6-7be2-46a5-9a98-b08bb8437dc0";
export const LIST_USERS="284aa15b-2f1a-4d09-aef7-2097df43dfdf";
export const LIST_SETTINGS="c0274cb5-96de-4c22-bf8a-f4dd9e51fccc";
export const LIST_PROJECTS="84d3bc82-c3fe-486e-8a7c-3b10e7f8677c";
export const LIST_FEEDBACK="f4108a5c-e19d-4a44-bee9-334620d60773";
export const LIST_HISTORY="ae4fc9f6-0c67-4fe5-b9bc-d7e5342db8d0";
// ⚠ Create TaskHub_Issues list in SharePoint first, then replace this placeholder
export const LIST_ISSUES="4e7a8bc6-4bc5-46fb-b31b-1ce90731e5ac";

export const STANDUP_REMINDER_DEFAULT="08:00";

// ── ProductTrack metadata ─────────────────────────────────────────────────
export const ISSUE_TYPE_META={
  bug_sw:{label:"SW Bug",color:"#DC2626",bg:"#FEF2F2"},
  bug_hw:{label:"HW Bug",color:"#EA580C",bg:"#FFF7ED"},
  enhance_sw:{label:"SW Enhancement",color:"#7C3AED",bg:"#F5F3FF"},
  enhance_hw:{label:"HW Enhancement",color:"#2563EB",bg:"#EFF6FF"},
  discovered:{label:"Discovered",color:"#64748B",bg:"#F1F5F9"},
};
export const ISSUE_SEVERITY_META={
  critical:{label:"Critical",color:"#DC2626",bg:"#FEF2F2"},
  high:{label:"High",color:"#EA580C",bg:"#FFF7ED"},
  medium:{label:"Medium",color:"#D97706",bg:"#FFFBEB"},
  low:{label:"Low",color:"#65A30D",bg:"#F7FEE7"},
};
export const ISSUE_STATUS_META={
  new:{label:"New",color:"#64748B",bg:"#F1F5F9"},
  triaged:{label:"Triaged",color:"#0EA5E9",bg:"#F0F9FF"},
  in_progress:{label:"In Progress",color:"#3B82F6",bg:"#EFF6FF"},
  testing:{label:"Testing",color:"#8B5CF6",bg:"#F5F3FF"},
  resolved:{label:"Resolved",color:"#10B981",bg:"#ECFDF5"},
  closed:{label:"Closed",color:"#475569",bg:"#F1F5F9"},
  wont_fix:{label:"Won't Fix",color:"#94A3B8",bg:"#F8FAFC"},
  deferred:{label:"Deferred",color:"#F59E0B",bg:"#FFFBEB"},
};
export const ISSUE_MILESTONES=["Now","Next","Soon","Backlog","Icebox"];
export const PT_ROLE_META={
  admin:{label:"PT Admin",color:"#7C3AED",bg:"#F5F3FF"},
  manager:{label:"PT Manager",color:"#2563EB",bg:"#EFF6FF"},
  contributor:{label:"Contributor",color:"#059669",bg:"#ECFDF5"},
  viewer:{label:"Viewer",color:"#64748B",bg:"#F1F5F9"},
  none:{label:"No Access",color:"#94A3B8",bg:"#F8FAFC"},
};

// Returns the most recent weekday date string YYYY-MM-DD
export function lastWeekday(){
  const d=new Date();
  const day=d.getDay();
  if(day===0) d.setDate(d.getDate()-2);
  else if(day===6) d.setDate(d.getDate()-1);
  return d.toISOString().slice(0,10);
}

// Returns true if a standup task has not had a note added since the last weekday
export function needsStandupUpdate(task){
  if(!task.standup) return false;
  const lastDay=lastWeekday();
  if(!task.standupHistory||task.standupHistory.length===0) return true;
  const sorted=[...task.standupHistory].sort((a,b)=>b.date.localeCompare(a.date));
  return sorted[0].date<lastDay;
}

export const VIS_META={
  personal:{label:"Personal",cls:"text-slate-500",bg:"bg-slate-100"},
  assigned:{label:"Assigned",cls:"text-blue-600",bg:"bg-blue-50"},
  company:{label:"Company",cls:"text-indigo-600",bg:"bg-indigo-50"}
};

export const DOC_META={
  sharepoint:{label:"SharePoint",cls:"bg-blue-50 text-blue-600"},
  onedrive:{label:"OneDrive",cls:"bg-sky-50 text-sky-600"},
  teams:{label:"Teams",cls:"bg-purple-50 text-purple-600"},
  outlook:{label:"Outlook",cls:"bg-orange-50 text-orange-600"}
};

export function fmtDate(d){
  if(!d) return"";
  const dt=new Date(d+"T12:00:00");
  return dt.toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});
}

export function isOverdue(task){
  if(!task.dueDate||task.sta==="completed") return false;
  return new Date(task.dueDate+"T23:59:59")<new Date();
}

export function isLocked(task,all){
  if(!task.deps||task.deps.length===0) return false;
  return task.deps.some(depId=>{
    // depId may be new prefixed format ("t-5","c-5") or legacy plain numeric ("5")
    const dep=all.find(t=>t.id===depId||t.spId===depId);
    return dep&&dep.sta!=="completed";
  });
}

export const DARK="#1A2332";

export const PRI_ORDER={high:0,medium:1,low:2};
export const STA_ORDER={todo:0,in_progress:1,blocked:2,review:3,completed:4,pending:5,declined:6};

export const PRIORITY={
  high:{label:"High",cls:"bg-red-50 text-red-600 border-red-200"},
  medium:{label:"Medium",cls:"bg-amber-50 text-amber-600 border-amber-200"},
  low:{label:"Low",cls:"bg-slate-50 text-slate-500 border-slate-200"}
};

export const STATUS={
  todo:{label:"To Do",cls:"bg-slate-100 text-slate-600 border-slate-200"},
  in_progress:{label:"In Progress",cls:"bg-blue-50 text-blue-600 border-blue-200"},
  review:{label:"Needs Approval",cls:"bg-purple-50 text-purple-600 border-purple-200"},
  completed:{label:"Completed",cls:"bg-emerald-50 text-emerald-600 border-emerald-200"},
  blocked:{label:"Blocked",cls:"bg-red-50 text-red-600 border-red-200"},
  pending:{label:"Pending",cls:"bg-amber-50 text-amber-600 border-amber-200"},
  declined:{label:"Declined",cls:"bg-slate-100 text-slate-500 border-slate-200"}
};

export const ACC_META={
  pending:{label:"Pending",cls:"bg-amber-50 text-amber-600 border-amber-200"},
  accepted:{label:"Accepted",cls:"bg-emerald-50 text-emerald-600 border-emerald-200"},
  declined:{label:"Declined",cls:"bg-red-50 text-red-600 border-red-200"}
};

export const ROLE_META={
  User:{cls:"bg-slate-100 text-slate-600 border-slate-200"},
  Manager:{cls:"bg-blue-50 text-blue-600 border-blue-200"},
  Admin:{cls:"bg-purple-50 text-purple-600 border-purple-200"}
};

export function newId(){
  return"local-"+Math.random().toString(36).slice(2,10)+"-"+Date.now().toString(36);
}

export function dispName(email,allUsers){
  if(allUsers&&allUsers.length){
    const rec=allUsers.find(u=>u.email.toLowerCase()===(email||"").toLowerCase());
    if(rec&&rec.displayName)return rec.displayName;
  }
  const local=(email||"").split("@")[0];
  return local.split(/[._-]/).map(p=>p.charAt(0).toUpperCase()+p.slice(1)).join(" ");
}

// Normalize email for comparison — matches Graph.js normEmail logic.
// Converts @dac-us.com UPNs and external accounts to a canonical form so
// cu.email (from MSAL) always matches the stored allUsers email.
function normEmailCompare(e){
  if(!e)return"";
  const[local]=e.toLowerCase().split("@");
  return local.replace(/_/g,".")+"@dacrobotics.com";
}

// Returns the list of users the current user is allowed to assign tasks to.
// All active users can assign to anyone (excluding themselves).
export function getAssignableUsers(cu,allUsers){
  if(!cu||!allUsers||!allUsers.length)return[];
  const cuEmail=normEmailCompare(cu.email);
  return allUsers.filter(u=>u.isActive&&normEmailCompare(u.email)!==cuEmail);
}

// Groups an assignable user list by role for use in <optgroup> dropdowns.
// Returns [{role, label, users}] sorted Admins → Managers → Users.
export function groupAssignableUsers(users){
  const order=["Admin","Manager","User"];
  const groups={Admin:[],Manager:[],User:[]};
  users.forEach(u=>{
    const r=(u.role||"User");
    const key=order.find(o=>o.toLowerCase()===(r).toLowerCase())||"User";
    groups[key].push(u);
  });
  return order
    .filter(r=>groups[r].length>0)
    .map(r=>({role:r,label:r==="Admin"?"Admins":r==="Manager"?"Managers":"Users",users:groups[r].sort((a,b)=>(a.displayName||"").localeCompare(b.displayName||""))}));
}

export function parseTeamsGroupName(name){
  const match=(name||"").match(/^(.+?):\s*([A-Z0-9]{3,5}-[A-Z0-9]{3,5})\s+(.+)$/i);
  if(!match)return null;
  return{customerName:match[1].trim(),jobNumber:match[2].trim().toUpperCase(),projectName:match[3].trim()};
}

export const INTERNAL_CATEGORIES=[
  {projectName:"Facility & Maintenance"},
  {projectName:"IT & Infrastructure"},
  {projectName:"Safety & Compliance"},
  {projectName:"Training & Development"},
  {projectName:"Administrative"},
  {projectName:"Sales & Quoting Support"},
  {projectName:"Internal R&D"},
  {projectName:"Quality & Process Improvement"},
  {projectName:"Shipping & Receiving"},
  {projectName:"Company Events & Meetings"},
];

// Calculate the next due date for a recurring task
export function nextRecurDate(recurrence, currentDueDate){
  const d=currentDueDate?new Date(currentDueDate+"T12:00:00"):new Date();
  const freq=recurrence?.freq||"weekly";
  if(freq==="daily"){
    d.setDate(d.getDate()+1);
  }else if(freq==="weekdays"){
    d.setDate(d.getDate()+1);
    while(d.getDay()===0||d.getDay()===6)d.setDate(d.getDate()+1);
  }else if(freq==="weekly"){
    if(recurrence?.days?.length>0){
      const dayMap={Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6,Sun:0};
      const targets=recurrence.days.map(x=>dayMap[x]).filter(x=>x!==undefined).sort((a,b)=>a-b);
      if(targets.length>0){
        const cur=d.getDay();
        const nxt=targets.find(x=>x>cur)??targets[0];
        const diff=nxt>cur?nxt-cur:7-cur+nxt;
        d.setDate(d.getDate()+(diff||7));
      }else{d.setDate(d.getDate()+7);}
    }else{d.setDate(d.getDate()+7);}
  }else if(freq==="biweekly"){
    d.setDate(d.getDate()+14);
  }else if(freq==="monthly"){
    d.setMonth(d.getMonth()+1);
  }else{
    // custom — interval days
    d.setDate(d.getDate()+(recurrence?.interval||7));
  }
  return d.toISOString().slice(0,10);
}

export function makeMockTasks(email){
  const today=new Date().toISOString().slice(0,10);
  const past=new Date(Date.now()-7*86400000).toISOString().slice(0,10);
  const soon=new Date(Date.now()+3*86400000).toISOString().slice(0,10);
  return[
    {id:"demo-1",spId:null,listType:"tasks",title:"Review Q2 project proposal",desc:"Review and provide feedback on the Q2 project proposal document.",pri:"high",sta:"in_progress",vis:"personal",dueDate:today,own:email,asgn:email,acc:"accepted",reqBy:"",blockReason:"",src:"manual",deps:[],tags:["planning"],notes:"",docs:[],reminderDate:"",reminderOutlook:false,reminderTeams:false,reminderEmail:false,standup:true,standupHistory:[],project:""},
    {id:"demo-2",spId:null,listType:"tasks",title:"Update team documentation",desc:"Update the internal wiki with recent process changes.",pri:"medium",sta:"todo",vis:"personal",dueDate:soon,own:email,asgn:email,acc:"accepted",reqBy:"",blockReason:"",src:"manual",deps:["demo-1"],tags:[],notes:"",docs:[],reminderDate:"",reminderOutlook:false,reminderTeams:false,reminderEmail:false,standup:false,standupHistory:[],project:""},
    {id:"demo-3",spId:null,listType:"tasks",title:"Submit weekly status report",desc:"Prepare and submit the weekly status report to leadership.",pri:"high",sta:"todo",vis:"personal",dueDate:past,own:email,asgn:email,acc:"accepted",reqBy:"",blockReason:"",src:"manual",deps:[],tags:["reporting"],notes:"",docs:[],reminderDate:"",reminderOutlook:false,reminderTeams:false,reminderEmail:false,standup:true,standupHistory:[],project:""},
  ];
}
